import { useFormContext } from "react-hook-form";
import type { UseMutationOptions } from "react-query";
import { useMutation } from "react-query";
import { useWorkflowsApi } from "@/react/api";
import { minimumDelay } from "@circle-react/helpers/dateTimeHelpers";

export const useRunWorkflow = (
  options: UseMutationOptions<undefined, Error, void> = {},
) => {
  const { watch } = useFormContext<{ id: string }>();
  const id = watch("id");
  const workflowsApi = useWorkflowsApi();

  return useMutation(
    () => minimumDelay(workflowsApi.createRun({ workflowId: id }), 500),
    {
      onError: error => {
        console.error(error);
      },
      ...options,
    },
  );
};
